import React from 'react';
import PropTypes from 'prop-types';

const RadioSwitch = ({ id, options, checked, handleOnChange, cssClass }) => {
    return (
        <div className={`form-control-radio-switch ${cssClass}`}>
            {options.map((option, index) => {
                return (
                    <div className="form-check form-check-inline" key={index}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name={`${id}-${option.name}`}
                            id={`${id}-${option.value}`}
                            value={option.value}
                            checked={option.value === checked}
                            onChange={e => {
                                handleOnChange(e.target.value);
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor={`${id}-${option.value}`}>
                            {option.name}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

RadioSwitch.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.node
        })
    ),
    checked: PropTypes.string,
    handleOnChange: PropTypes.func,
    cssClass: PropTypes.string,
    id: PropTypes.string.isRequired
};

RadioSwitch.defaultProps = {
    cssClass: ''
};

export default RadioSwitch;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/form-controls/radio-switch.jsx